import { DateTime } from "luxon";

export const timeZoneOffset = (dateValue) => {
	console.log("5 date value:", dateValue);

	const dateTimezoneOffset = new Date().getTimezoneOffset();
	console.log("5 timezone offset:", dateTimezoneOffset);

	let formattedDate;

	if (dateTimezoneOffset > 0) {
		formattedDate = DateTime.fromISO(dateValue, { zone: "utc" })
			.plus({
				hour: dateTimezoneOffset / 60,
			})
			.toFormat("MM-dd-yyyy");
	} else {
		formattedDate = DateTime.fromISO(dateValue, { zone: "utc" })
			.minus({
				hour: dateTimezoneOffset / 60,
			})
			.toFormat("MM-dd-yyyy");
	}

	console.log("25 invalid date:", formattedDate === "Invalid DateTime");
	console.log("25 formatted date:", formattedDate);
	return formattedDate;
};
export const convertUTCToEastern = (utcDateString) => {
	if (!utcDateString) return null;

	try {
		// Convert UTC to Eastern timezone
		const easternDateTime = DateTime.fromISO(utcDateString, { zone: "utc" })
			.setZone("America/New_York");

		// Format as "M/d/yyyy h:mm a ET"
		return easternDateTime.toFormat("M/d/yyyy h:mm a 'ET'");
	} catch (error) {
		console.error("Error converting UTC to Eastern:", error);
		return null;
	}
};



export const convertUTCtoEst = (
	utcTime,
	options = { includeTime: false, use12Hour: false, appendET: false }
  ) => {
	const { includeTime = true, use12Hour = false, appendET = false } = options;
  
	try {
	  // Parse UTC time correctly
	  const dateInUTC = new Date(utcTime); // "Z" means UTC
  
	  // Build formatting options
	  const formatOptions = {
		timeZone: "America/New_York", // Handles EST/EDT automatically
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
	  };
  
	  if (includeTime) {
		formatOptions.hour = "2-digit";
		formatOptions.minute = "2-digit";
		formatOptions.second = "2-digit";
		formatOptions.hour12 = use12Hour;
	  }
  
	  const formatter = new Intl.DateTimeFormat("en-US", formatOptions);
	  let formatted = formatter.format(dateInUTC);
  
	  if (includeTime && appendET) {
		formatted += " ET";
	  }
  
	  return formatted;
	} catch (error) {
	  console.error("Invalid date format:", error);
	  return null;
	}
  };
  
  
  
export const convertCSTtoEST = (
	cstTime,
	options = { includeTime: false, use12Hour: false, appendET: false }
  ) => {
	const { includeTime = true, use12Hour = false, appendET = false } = options;
    if (cstTime === "" || cstTime === "12/31/599"){
		return "NA"
	}
	try {
	  // Parse CST time as Date object assuming CST timezone
	  const dateInCST = new Date(cstTime + " GMT-0600"); // CST offset
  
	  // Build formatting options
	  const formatOptions = {
		timeZone: "America/New_York", // EST/EDT zone
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
	  };
  
	  if (includeTime) {
		formatOptions.hour = "2-digit";
		formatOptions.minute = "2-digit";
		formatOptions.second = "2-digit";
		formatOptions.hour12 = use12Hour;
	  }
  
	  const estFormatter = new Intl.DateTimeFormat("en-US", formatOptions);
	  let formatted = estFormatter.format(dateInCST);
  
	  // Append " ET" if requested and time is included
	  if (includeTime && appendET) {
		formatted += " ET";
	  }
  
	  return formatted;
	} catch (error) {
	  console.error("Invalid date format:", error);
	  return null;
	}
  };
  